import { defaultTransformFn, dsApi } from "./DsApi";
import { User } from "../entities/User";
import { UserRoleType } from "authentication/UserRoleType";
import moment from "moment";
import { UserCommissionRates } from "../entities/UserCommissionRates";

const usersTags = dsApi.enhanceEndpoints({
  addTagTypes: ["Users", "UsersCommissionRates"],
});

const usersApi = usersTags.injectEndpoints({
  endpoints: (build) => ({
    getUsers: build.query<User[], void>({
      query: () => {
        return {
          url: `users`,
          method: "GET",
        };
      },
      transformResponse: defaultTransformFn,
      providesTags: () => [{ type: "Users" }],
    }),
    getUsersCommissionRates: build.query<
      UserCommissionRates[],
      {
        forMonth: moment.Moment;
      }
    >({
      query: () => {
        return {
          url: `users/getAllUserCommissionRate`,
          method: "GET",
        };
      },
      transformResponse: defaultTransformFn,
      providesTags: () => [{ type: "UsersCommissionRates" }],
    }),
    createUser: build.mutation<
      User,
      {
        email: string;
        firstName: string;
        lastName: string;
        password: string;
        phoneNumber: string;
      }
    >({
      query: (user) => ({
        url: `users`,
        method: "POST",
        data: {
          email: user.email,
          firstName: user.firstName,
          lastName: user.lastName,
          password: user.password,
          phoneNumber: user.phoneNumber,
        },
      }),
      transformResponse: defaultTransformFn,
      invalidatesTags: [{ type: "Users" }],
    }),
    updateUser: build.mutation<
      User,
      { userId: string; role: UserRoleType; phoneNumber: string }
    >({
      query: ({ userId, role, phoneNumber }) => ({
        url: `users/${userId}`,
        method: "PUT",
        data: {
          newRole: role,
          newPhoneNumber: phoneNumber,
        },
      }),
      transformResponse: defaultTransformFn,
      invalidatesTags: [{ type: "Users" }],
    }),
    resetUserPassword: build.mutation<void, { email: string }>({
      query: ({ email }) => ({
        url: `login/resetPassword`,
        method: "POST",
        data: {
          email: email,
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetUsersQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useResetUserPasswordMutation,
  useGetUsersCommissionRatesQuery,
} = usersApi;
